export enum BuildPhase {
	LOAD_AND_PARSE = 0,
	ANALYSE,
	GENERATE
}
